export default function (toValidate, options = {}) {
    if (!toValidate) return true;
    const { maxCount } = options;
    const length = toValidate.length || 0;
    if (typeof maxCount !== "number") return true;
    if (typeof length !== "number") return true;
    return length <= maxCount;
}
